import { render, staticRenderFns } from "./news-system.vue?vue&type=template&id=4d37b1ce&scoped=true&"
import script from "./news-system.vue?vue&type=script&lang=js&"
export * from "./news-system.vue?vue&type=script&lang=js&"
import style0 from "./news-system.vue?vue&type=style&index=0&id=4d37b1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d37b1ce",
  null
  
)

export default component.exports